import { render, staticRenderFns } from "./SectionRows.vue?vue&type=template&id=0150da9d&"
import script from "./SectionRows.vue?vue&type=script&lang=js&"
export * from "./SectionRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports